module.exports = __webpack_public_path__ + "img/model-2@2x.9f87cbb.webp";